<template>
  <DashboardAppointments />
</template>

<script>
import DashboardAppointments from '@/components/dashboard/DashboardAppointments'
export default {
  components: { DashboardAppointments }
}
</script>
